import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { Mail, CheckCircle, AlertCircle, Loader } from 'lucide-react';

const NewsletterConfirm = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    const email = searchParams.get('email');
    const token = searchParams.get('token');

    if (!email || !token) {
      setLoading(false);
      setError('Invalid confirmation link.');
      return;
    }

    let cancelled = false;

    fetch('/api/newsletter/confirm', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email, token }),
    })
      .then(async (res) => {
        const data = await res.json().catch(() => ({}));
        if (!res.ok) throw new Error(data.error || 'Confirmation failed');
        if (!cancelled) {
          setMessage(data.message || 'Your subscription is confirmed.');
        }
      })
      .catch((err) => {
        if (!cancelled) {
          setError(err.message || 'Confirmation failed. Please try again.');
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams]);

  return (
    <div className="page-content info-page newsletter-page">
      <header className="info-page-header">
        <h2>
          <Mail size={22} className="info-page-header-icon" aria-hidden />
          Newsletter
        </h2>
      </header>

      <div className="newsletter-confirm-card info-data-card">
        {loading && (
          <div className="newsletter-confirm-state" role="status">
            <Loader size={28} className="spinning" aria-hidden />
            <p>Confirming your subscription…</p>
          </div>
        )}

        {!loading && message && (
          <div className="newsletter-confirm-state newsletter-confirm-state--success" role="status">
            <CheckCircle size={40} aria-hidden />
            <h3>Subscription confirmed</h3>
            <p>{message}</p>
            <Link to="/" className="pw-btn pw-btn-primary">Go to dashboard</Link>
          </div>
        )}

        {!loading && error && (
          <div className="newsletter-confirm-state newsletter-confirm-state--error" role="alert">
            <AlertCircle size={40} aria-hidden />
            <h3>Confirmation failed</h3>
            <p>{error}</p>
            <Link to="/newsletter" className="pw-btn pw-btn-primary">Back to newsletter</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default NewsletterConfirm;
